<template>
  <div
    v-if="hasErrors"
    ref="formErrors"
    class="form-errors"
  >
    <fn-action-box-notification
      v-for="(error, index) in unref(errors)?.general"
      :key="`${index}`"
      error
      inline-links
    >
      <span v-html="translateError(error)" />
    </fn-action-box-notification>
  </div>
</template>

<script setup lang="ts">
import type { HTMLElementRef } from '@/types/forms';

const props = defineProps<{
  errors?: {
    general?: Array<string>;
  };
}>();

const formErrors = ref() as HTMLElementRef;

const hasErrors = computed(() => {
  return unref(props.errors) && unref(props.errors)?.general;
});

watch(
  () => props.errors,
  async () => {
    if (!hasErrors) {
      return;
    }

    // Need to access DOM after DOM-update with nextTick
    await nextTick();

    // Scroll to error box
    unref(formErrors)?.scrollIntoView({
      behavior: 'smooth',
    });
  },
  { deep: true, immediate: true },
);
</script>

<style lang="scss" scoped>
.form-errors {
  margin-bottom: $pad;
  scroll-margin: 10px;

  &:last-child {
    margin-bottom: 0;
  }

  // Account for the sticky header when scrolling into view
  @include bp(m, max) {
    scroll-margin: 120px;
  }
}
</style>
